<template>
    <table class="table table-bordered table-responsive-xl table-hover display">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ $t('addresses.address') }}</th>
          <th>{{ $t('addresses.owner') }}</th>
          <th>{{ $t('departures.user_id') }}</th>
          <th>{{ $t('departures.created_at') }}</th>
          <th>{{ $t('calls.call_status_name') }}</th>
          <th>{{ $t('calls.result_dialog.name') }}</th>
          <th>{{ $t('debts.next_contact_short') }}</th>
          <th>{{ $t('calls.promised_amount') }}</th>
          <th>{{ $t('calls.promised_date') }}</th>
          <th>{{ $t('app.comment') }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="!loadDepartures">
          <tr v-for="(departure, index) in departures" :key="index">
            <td>{{++index}}</td>
            <td>{{departure.address ? departure.address.address:''}}</td>
            <td>
              {{departure.address ? (departure.address.debtor ? departure.address.debtor.fullname : departure.address.contact_face.fullname):''}}<br>
              <span class="badge badge-pill" :class="{'badge-success':departure.address.contact_face, 'badge-info': departure.address.debtor}">{{departure.who}}</span>
            </td>
            <td>{{departure.user.firstname}} {{departure.user.lastname}}</td>
            <td>{{departure.created_at | datetimeFormat}}</td>
            <td>{{departure.status ? departure.status.name: ''}}</td>
            <td>{{departure.result_dialog ? departure.result_dialog.name: ''}}</td>
            <td>{{departure.next_contact | dateFormat}}</td>
            <td>{{departure.promised_payment.amount}}</td>
            <td>{{departure.promised_payment.promised_date | dateFormat}}</td>
            <td>{{departure.comment}}</td>
          </tr>
        </template>
        <tr v-if="loadDepartures">
          <td colspan="12" class="text-center">
            <div class='sk-wave'>
              <div class='sk-rect sk-rect-1'></div>
              <div class='sk-rect sk-rect-2'></div>
              <div class='sk-rect sk-rect-3'></div>
              <div class='sk-rect sk-rect-4'></div>
              <div class='sk-rect sk-rect-5'></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      isProcessing: false,
      loadDepartures: false,
    };
  },
  computed: {
    ...mapGetters([
      'departures',
    ]),
  },
  mounted() {
    this.GET_DEPARTURES(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'GET_DEPARTURES',
    ]),
  },
  watch: {
    '$route.params.id': function $routeParamsId() {
      this.GET_DEPARTURES(this.$route.params.id);
    },
  },
};
</script>
